const theme = {
  primary: '#1A4AC2',
  primaryDark: '#113BA4',
  secondary: '#052475',
  primaryLight: '#EFF4FF',
  secondaryLight: '#D6E0F5',
  tertiary: '#3368F2',
  white: '#ffffff',
  dark: '#252C3C',
  black: '#000000',
  backgroundSecondary: '#f7f7f7',
  danger: '#F23356',
  danger2: '#D14949',
  dangerDark: '#cb314e',
  error: 'red',
  mainFont: 'Poppins, sans-serif',
  secondaryFont: 'Open Sans, sans-serif',
};

export default theme;
